import { isNull } from '@/shared/utils/utils';
const oss = require('ali-oss');
import moment from 'moment';
export default class UploadFile {
  public static addFileAliyun(file: any, fileName: string = '') {
    return new Promise((resolve) => {
      const client = new oss({
        region: process.env.VUE_APP_OSS_Region,
        accessKeyId: process.env.VUE_APP_OSS_AccessKeyId,
        accessKeySecret: process.env.VUE_APP_OSS_AccessKeySecret,
        bucket: process.env.VUE_APP_OSS_Bucket
      });
      if (isNull(fileName)) {
        fileName = file.name;
      }
      const key = `${moment(new Date()).format('YYYYMMDDHHmmss')}${(((Math.random() + 1) * Math.pow(10, 12))).toFixed(0)}`;
      client.put(`${key}/${fileName}`, file)
        .then((response: any) => {
          resolve(response);
        }).catch((err: any) => {
          console.log(err);
        });
    });

  }
}
